export var VERSION = '2.11.9';
//# sourceMappingURL=version.js.map